// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TNvr","colBig":"styles_colBig__2NmZ2","colSmall":"styles_colSmall__urBpt"};